import { FormattedMessage, useIntl } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";

const Whiteboards = () => {
    const intl = useIntl();

    return (
        <div>
            <h2>
                <FormattedMessage
                    id="ConfluencePricingPage.modalContents.Whiteboards.header"
                    defaultMessage="Whiteboards"
                />
            </h2>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPage.modalContents.Whiteboards.summary"
                    defaultMessage="Confluence whiteboards brings the flexibility of a digital whiteboard into your team workspace, allowing you to brainstorm, plan, and action work like never before. <a>Learn more</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-label-english="Learn more"
                                data-track-event="ConfluencePricingPage.whiteboards.learnMore"
                                data-event-container="ConfluencePricingPage"
                                // eslint-disable-next-line react-hooks/rules-of-hooks
                                href={`${useLocalizedHref(
                                    "/software/confluence/whiteboards"
                                )}`}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
            <div>
                <img
                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/whiteboards.webp"
                    alt={intl.formatMessage({
                        id: "ConfluencePricingPage.features.Whiteboards.altText",
                        defaultMessage: "Whiteboards"
                    })}
                    height={350}
                    loading="lazy"
                />
            </div>
        </div>
    );
};

export default Whiteboards;
